import React from 'react';
//import PropTypes from 'prop-types';

import decorate from '../common/utils/decorate';
import AddressInput from '../common/components/AddressInput';
import DeliveryWidgetContext from '../contexts/DeliveryWidgetContext';
import Button from '../ui/Button';
import Card from '../ui/Card';
import Checkbox from '../ui/Checkbox';
import Grid from '../ui/Grid';
import Skeleton from '../ui/Skeleton';
import Text from '../ui/Text';
import TextInput from '../ui/TextInput';
import Logo from '../ui/Logo';

export default decorate(
  class extends React.PureComponent {
    static contextType = DeliveryWidgetContext;

    static decorateWith = {};

    static propTypes = {};

    static defaultProps = {};

    constructor(props) {
      super(props);

      this.state = {};
    }

    formatQueryPrice = (price, from = true) => {
      const { langString, priceFormat } = this.context;

      const minPrice = Array.isArray(price) ? price[0] : price;

      return minPrice ? (
        <>
          {from ? (
            <>
              {langString('from')}
              &nbsp;
            </>
          ) : null}

          {priceFormat(minPrice)}
        </>
      ) : (
        /*langString('free')*/ '-'
      );
    };

    renderMethodsCard = (showMethodList) => {
      const {
        localityData,
        onLocalityData,

        method,
        onMethod
      } = this.props;

      const {
        editor,

        langString,
        daysFormat,

        isSmall
      } = this.context;

      return (
        <Card>
          <Grid container>
            <Grid>
              <Card variant="bordered">
                <Text size="xs2">{langString('city.enter')}</Text>
                <AddressInput
                  variant="delivery"
                  determineAddress={false}
                  defaultValue={editor?.address?.locality}
                  selectedItem={localityData}
                  onSelectItem={onLocalityData}
                  InputComponent={TextInput}
                />
              </Card>

              {localityData ? (
                <>
                  {!showMethodList || showMethodList.length ? (
                    <>
                      {!showMethodList ? (
                        <Card variant="bordered">
                          <Checkbox disabled variant="radio">
                            <Text strong>
                              <Skeleton />
                            </Text>
                            <Text size="sm">
                              <Skeleton />
                            </Text>
                            <Text size="sm">
                              <Skeleton />
                            </Text>
                          </Checkbox>
                        </Card>
                      ) : (
                        <>
                          {showMethodList.map((item, index) => (
                            <Card key={index} variant="bordered">
                              <Checkbox
                                variant="radio"
                                checked={method === item.value}
                                onChange={(event) => onMethod(item.method.id)}
                              >
                                <Text strong>{item.method.title}</Text>
                                <Text size="sm">
                                  ({daysFormat(item.query.days)}
                                  ,&nbsp;
                                  {this.formatQueryPrice(item.query.price)})
                                </Text>
                              </Checkbox>
                            </Card>
                          ))}
                        </>
                      )}
                    </>
                  ) : null}
                </>
              ) : null}

              {!isSmall || !localityData ? this.renderCancelButton() : null}
            </Grid>
          </Grid>
        </Card>
      );
    };

    renderCompaniesCard = (showMethodList, showCompanyList) => {
      const {
        localityData,

        company,
        onCompany
      } = this.props;

      const { langString, daysFormat } = this.context;

      return (
        <>
          {localityData ? (
            <Card>
              <Grid container>
                <Grid>
                  {localityData ? (
                    <>
                      {!showMethodList || showMethodList.length ? (
                        <>
                          <Text strong size="xl2">
                            {langString('delivery.service')}
                          </Text>

                          {!showCompanyList ? (
                            <Card variant="bordered">
                              <Checkbox disabled variant="radio">
                                <Text strong>
                                  <Skeleton />
                                </Text>
                                <Text size="sm">
                                  <Skeleton />
                                </Text>
                                <Text size="sm">
                                  <Skeleton />
                                </Text>
                              </Checkbox>
                            </Card>
                          ) : (
                            <>
                              {showCompanyList.map((item, index) => (
                                <Card key={index} variant="bordered">
                                  <Checkbox
                                    variant="radio"
                                    checked={company === item.value}
                                    onChange={(event) =>
                                      onCompany(item.company.id)
                                    }
                                  >
                                    <Grid container>
                                      <Grid grow={1}>
                                        <Text strong>{item.company.title}</Text>
                                      </Grid>
                                      {item.company.logo_path ? (
                                        <Grid grow={0}>
                                          <Logo
                                            variant="right"
                                            src={item.company.logo_path}
                                          />
                                        </Grid>
                                      ) : null}
                                    </Grid>

                                    <Text size="sm">
                                      ({daysFormat(item.query.days)}
                                      ,&nbsp;
                                      {this.formatQueryPrice(item.query.price)})
                                    </Text>
                                  </Checkbox>
                                </Card>
                              ))}
                            </>
                          )}
                        </>
                      ) : (
                        <Text variant="danger">
                          {langString('delivery.nfound')}
                        </Text>
                      )}
                    </>
                  ) : null}
                </Grid>
              </Grid>
            </Card>
          ) : null}
        </>
      );
    };

    renderTariffsCard = (showMethodList, showTariffList) => {
      const {
        localityData,

        company,

        tariff,
        onTariff
      } = this.props;

      const {
        daysFormat,

        service,

        isSmall
      } = this.context;

      return (
        <>
          {localityData ? (
            <Card>
              <Grid container>
                <Grid>
                  {localityData ? (
                    <>
                      {!showMethodList || showMethodList.length ? (
                        <>
                          {!showTariffList ? (
                            <Card variant="bordered">
                              <Checkbox disabled variant="radio">
                                <Text strong>
                                  <Skeleton />
                                </Text>
                                <Text size="sm">
                                  <Skeleton />
                                </Text>
                                <Text size="sm">
                                  <Skeleton />
                                </Text>
                              </Checkbox>
                            </Card>
                          ) : (
                            <>
                              {showTariffList.map((item, index) => (
                                <Card key={index} variant="bordered">
                                  <Checkbox
                                    variant="radio"
                                    checked={
                                      service.id === item.tariff.service.id &&
                                      company === item.tariff.company &&
                                      tariff === item.tariff.id
                                    }
                                    onChange={(event) =>
                                      onTariff(
                                        item.tariff.service.id,
                                        item.tariff.company,
                                        item.tariff.id
                                      )
                                    }
                                  >
                                    <Text strong>{item.tariff.title}</Text>
                                    <Text size="sm">
                                      ({daysFormat(item.query.days)}
                                      ,&nbsp;
                                      {this.formatQueryPrice(item.query.price)})
                                    </Text>
                                  </Checkbox>
                                </Card>
                              ))}
                            </>
                          )}
                        </>
                      ) : null}
                    </>
                  ) : null}

                  {isSmall ? this.renderCancelButton() : null}
                </Grid>
              </Grid>
            </Card>
          ) : null}
        </>
      );
    };

    renderCancelButton = () => {
      const { onPrevPage } = this.props;
      
      const {
        langString,
        
        deliveryInfo
      } = this.context;
      
      if (!deliveryInfo?.address?.length)
        return null;
      
      return (
        <Button variant="outlined" onClick={onPrevPage}>
          {langString('cancel')}
        </Button>
      );
    };

    componentDidMount() {}

    componentWillUnmount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {}

    render() {
      const {
        localityData,

        method,
        onMethod,

        company,
        onCompany,

        tariff,

        onNextPage
      } = this.props;

      const {
        langString,
        
        service,
        method: methodInfo,
        methodList,
        methodQuery,
        companyList,
        tariffList,

        isSmall
      } = this.context;
      
      const showMethodList =
        localityData && methodList && methodQuery
          ? methodList
              .map((method) => {
                const query = methodQuery[method.id];
                return query && { value: method.id, method, query };
              })
              .filter((item) => item)
          : null;
      
      const showCompanyList =
        showMethodList && companyList && service && method
          ? companyList
              .map((company) => {
                const query = company.service.id !== service.id && methodQuery[method]?.companies.find((item) => item.id === company.id);
                
                return query && { value: company.id, company, query };
              })
              .filter((item) => item)
          : null;
      
      const showTariffList =
        showCompanyList && tariffList && company
          ? methodQuery[method]?.tariffs
              .map((query) => {
                if (query.company !== company) return;

                const tariff = tariffList.find(
                  (item) =>
                    item.service.id === query.service.id &&
                    item.company === query.company &&
                    item.id === query.id
                );

                return (
                  tariff && {
                    value:
                      tariff.service.id +
                      '-' +
                      tariff.company +
                      '-' +
                      tariff.id,
                    tariff,
                    query
                  }
                );
              })
              .filter((item) => item)
          : null;

      if (showMethodList?.length && (!method || !showMethodList.find((item) => item.method.id === method)))
        setTimeout(() => onMethod(showMethodList[0].method.id), 1);

      if (showCompanyList?.length && (!company || !showCompanyList.find((item) => item.company.id === company)))
        setTimeout(() => onCompany(showCompanyList[0].company.id), 1);

      if (isSmall) {
        return (
          <Grid container>
            <Grid>
              {this.renderMethodsCard(showMethodList)}
              {this.renderCompaniesCard(showMethodList, showCompanyList)}
              {this.renderTariffsCard(showMethodList, showTariffList)}

              <Button
                variant="contained"
                disabled={!showTariffList || !tariff}
                onClick={onNextPage}
              >
                {langString(
                  methodInfo?.code === 'pickup'
                    ? 'point.goto'
                    : 'recipient.goto'
                )}
              </Button>
            </Grid>
          </Grid>
        );
      } else {
        return (
          <Grid container>
            <Grid>{this.renderMethodsCard(showMethodList)}</Grid>

            <Grid>
              {this.renderCompaniesCard(showMethodList, showCompanyList)}
              {this.renderTariffsCard(showMethodList, showTariffList)}

              <Button
                variant="contained"
                disabled={!showTariffList || !tariff}
                onClick={onNextPage}
              >
                {langString(
                  methodInfo?.code === 'pickup'
                    ? 'point.goto'
                    : 'recipient.goto'
                )}
              </Button>
            </Grid>
          </Grid>
        );
      }
    }
  }
);
